import { Box } from '@mui/material';

import { DrawerFormSection } from '../../../../common/components';
import {
  formatAmount,
  formatCurrencyAmount,
} from '../../utils/supplierLedgerFormatters';
import {
  AmountPanel,
  InvoiceSummaryItem,
} from '../SupplierLedgerShared';
import PaymentOrderProviderHeader from './PaymentOrderProviderHeader';

const PaymentOrderSummarySection = ({ controller }) => {
  const {
    activeProvider,
    activeProviderIncludedInvoices,
    activeProviderOrderGroups,
    activeProviderTotal,
    activeProviderTotalArs,
    includedSelectedInvoices,
    providerCount,
    totalArs,
  } = controller;

  return (
    <>
      <PaymentOrderProviderHeader controller={controller} />
      <DrawerFormSection title="Resumen de pago" grid={false}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
            gap: 1.5,
            alignItems: 'stretch',
            mb: 1.5,
          }}
        >
          <AmountPanel
            label={activeProviderOrderGroups.length > 1 ? 'Total proveedor ARS' : `Total ${activeProviderOrderGroups[0]?.currency || 'ARS'}`}
            value={activeProviderOrderGroups.length > 1
              ? formatAmount(activeProviderTotalArs)
              : formatCurrencyAmount(activeProviderTotal, activeProviderOrderGroups[0]?.currency || 'ARS')}
          />
          <InvoiceSummaryItem label="Facturas del proveedor" value={activeProvider?.invoices.length || 0} highlight />
          <InvoiceSummaryItem label="Facturas incluidas" value={activeProviderIncludedInvoices.length} highlight />
        </Box>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' },
            gap: 1.5,
          }}
        >
          <InvoiceSummaryItem label="Total lote ARS" value={formatAmount(totalArs)} highlight />
          <InvoiceSummaryItem label="Proveedores del lote" value={providerCount} />
          <InvoiceSummaryItem label="Facturas incluidas en lote" value={includedSelectedInvoices.length} />
        </Box>
      </DrawerFormSection>
    </>
  );
};

export default PaymentOrderSummarySection;
